import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import AppViewSheetBreadcrumb from "@/v2-backoffice-client/app/AppViewSheetBreadcrumb"
import Tabs from "@/v2-backoffice-client/components/tabs"
import FeatureAvailabilityTab from "@/v2-backoffice-client/feature/availability/FeatureAvailabilityTab"
import { FEATURE_TAB } from "@/v2-backoffice-client/feature/feature.constants"
import { useBasemapViewQuery } from "@/v2-backoffice-client/basemap/view/basemap.view.query"
import BasemapViewDetails from "@/v2-backoffice-client/basemap/view/BasemapViewDetails"
import BasemapViewInfo from "@/v2-backoffice-client/basemap/view/BasemapViewInfo"
import BasemapViewToolbar from "@/v2-backoffice-client/basemap/view/BasemapViewToolbar"
import BasemapUpdateEditor from "@/v2-backoffice-client/basemap/update/BasemapUpdateEditor"
import {
  BASEMAP_VIEW_DEFAULT_TAB,
  BASEMAP_VIEW_TABS_ID,
} from "@/v2-backoffice-client/basemap/basemap.constants"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"

function BasemapViewSheet() {
  const { id } = useAppViewSheetOpener()
  const featureCode = String(id)

  const { data, loading, error } = useBasemapViewQuery({
    skip: !featureCode,
    variables: { featureCode },
  })

  const basemap = data?.getBasemapByFeatureCode

  return (
    <>
      <ViewSheet.Header>
        <AppViewSheetBreadcrumb />
        <ViewSheet.Title isLoading={loading}>
          {basemap?.Name ?? basemap?.FeatureCode}
        </ViewSheet.Title>
      </ViewSheet.Header>

      <ViewSheet.HeaderRow>
        <BasemapViewInfo basemap={basemap} isLoading={loading} />
        <BasemapViewToolbar basemap={basemap} />
      </ViewSheet.HeaderRow>

      <Tabs
        id={BASEMAP_VIEW_TABS_ID}
        defaultValue={BASEMAP_VIEW_DEFAULT_TAB}
        isLoading={loading}
        error={error}
        isEmpty={!basemap}
        emptyLabel="Basemap not found."
      >
        <Tabs.List>
          <Tabs.Trigger value={FEATURE_TAB.details}>Details</Tabs.Trigger>
          <Tabs.Trigger value={FEATURE_TAB.configuration}>
            Configuration
          </Tabs.Trigger>
          <Tabs.Trigger value={FEATURE_TAB.availability}>
            Availability
          </Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value={FEATURE_TAB.details} className="flex-1">
          {basemap && <BasemapViewDetails basemap={basemap} />}
        </Tabs.Content>

        <Tabs.Content value={FEATURE_TAB.configuration} className="flex-1">
          <BasemapUpdateEditor basemap={basemap} />
        </Tabs.Content>

        <Tabs.Content value={FEATURE_TAB.availability} className="flex-1">
          {basemap && (
            <FeatureAvailabilityTab
              featureCode={basemap.FeatureCode}
              subject="basemap"
              featureCodeLabel="Basemaps"
            />
          )}
        </Tabs.Content>
      </Tabs>
    </>
  )
}

export default BasemapViewSheet
